<div class="config-container">
  <header class="config-header">
    <h1>新規マッピング</h1>
  </header>

  @if (catalogError()) {
    <div class="error-banner">{{ catalogError() }}</div>
  }
  @if (executeError()) {
    <div class="error-banner">{{ executeError() }}</div>
  }
  @if (entitySchemaError()) {
    <div class="error-banner">{{ entitySchemaError() }}</div>
  }

  <form [formGroup]="form" class="glass-form" (ngSubmit)="execute()">
    <section class="form-section">
      <div class="section-title">
        <span class="icon">🔗</span>
        <h2>入力</h2>
      </div>

      <div class="grid-fields">
        <div class="form-group span-two">
          <label for="searchPath">
            検索パス
            <span class="field-hint">例: //garage-petabo/test/data/...</span>
          </label>
          <input id="searchPath" type="text" formControlName="searchPath" />
        </div>

        <div class="form-group">
          <label for="entitySchemaId">
            EntitySchema（カタログ）
            <span class="field-hint">`settings/test/entitySchema/catalog` から取得</span>
          </label>
          <select id="entitySchemaId" formControlName="entitySchemaId" [disabled]="loadingCatalog()">
            @for (item of catalogItems(); track item.id) {
              <option [value]="item.id">{{ item.name || item.id }}</option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="schemaPath">
            schemaPath
            <span class="field-hint">converter に渡すパス（自動セット、手動変更も可）</span>
          </label>
          <input id="schemaPath" type="text" formControlName="schemaPath" />
        </div>
      </div>
    </section>

    <section class="form-section">
      <div class="section-title">
        <span class="icon">🧩</span>
        <h2>View Schema</h2>
        <span class="section-hint">まずは動作確認用（後で entitySchema と紐づけ強化）</span>
      </div>

      <app-view-schema-editor
        formControlName="viewSchemaJson"
        mode="indexApp"
        [fieldKeys]="entityFieldKeySuggestions()"
      ></app-view-schema-editor>
    </section>

    <section class="form-section">
      <div class="section-title">
        <span class="icon">🗺️</span>
        <h2>マッピング</h2>
        <span class="section-hint">接続 → formula 自動生成</span>
      </div>

      <app-mapping-editor
        [entityFields]="entityFields()"
        [viewFields]="viewFields()"
        [connections]="mappingConnections()"
        (connectionsChange)="handleConnectionsChange($event)"
      ></app-mapping-editor>
    </section>

    <section class="form-section">
      <div class="section-title">
        <span class="icon">📄</span>
        <h2>EntitySchema（取得結果）</h2>
        <span class="section-hint">index-core から schemaPath を取得して確認</span>
      </div>

      @if (loadingEntitySchema()) {
        <div class="results-loading">EntitySchema を読み込んでいます...</div>
      } @else if (entitySchemaJson()) {
        <div class="raw-container glass-card">
          <pre>{{ entitySchemaJson() }}</pre>
        </div>
      } @else {
        <div class="empty-state glass-card">
          <p>EntitySchema が未取得です。</p>
        </div>
      }
    </section>

    <footer class="form-footer">
      <button type="button" class="submit-btn" (click)="loadCatalog()" [disabled]="loadingCatalog()">
        {{ loadingCatalog() ? '読込中...' : 'カタログ再読込' }}
      </button>
      <button
        type="button"
        class="submit-btn"
        (click)="loadEntitySchema(form.get('schemaPath')?.value || '')"
        [disabled]="loadingEntitySchema() || !form.get('schemaPath')?.value"
      >
        {{ loadingEntitySchema() ? '取得中...' : 'schemaPath取得' }}
      </button>

      <button type="submit" class="execute-btn" [disabled]="isExecuting() || form.invalid">
        @if (isExecuting()) {
          <span class="btn-loader"></span>実行中...
        } @else {
          ▶ converter 実行
        }
      </button>
    </footer>
  </form>

  @if (resultJson()) {
    <section class="results-section glass-form">
      <div class="section-title">
        <span class="icon">✅</span>
        <h2>結果</h2>
      </div>
      <div class="raw-container glass-card">
        <pre>{{ resultJson() }}</pre>
      </div>
    </section>
  }
</div>

